import React from "react";
import Svg, { G, Path, Ellipse } from "react-native-svg";

const Crown = ({ width, height }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 26 17"
      preserveAspectRatio="xMidYMin meet"
    >
      <G
        id="Onboarding"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <G
          id="iPhone-8-Copy-267"
          transform="translate(-91.000000, -106.000000)"
          fillRule="nonzero"
        >
          <G id="crown" transform="translate(91.000000, 106.000000)">
            <Path
              d="M23.8368428,2.22219522 C22.6400564,2.22219522 21.6698387,3.21714659 21.6698387,4.44444252 C21.6702958,4.67741207 21.7068637,4.90881913 21.7781711,5.13001781 L20.0207275,6.27559471 C18.8636071,7.031639 17.3380142,6.78106521 16.4690185,5.69225935 L14.7462636,3.53115809 C15.0204214,3.1526672 15.168623,2.69375935 15.1688261,2.2222473 C15.1688261,0.994951371 14.1986084,0 13.0018219,0 C11.8050355,0 10.8348178,0.994951371 10.8348178,2.2222473 C10.8350209,2.69375935 10.9832225,3.1526672 11.2573803,3.53115809 L9.53462542,5.69225935 C8.66578204,6.78044021 7.1409002,7.03096191 5.98403374,6.27559471 L4.22562517,5.13001781 C4.29698338,4.90881913 4.33355129,4.67741207 4.3339576,4.44444252 C4.33416076,3.21714659 3.36414616,2.22203897 2.16730895,2.22183063 C0.970573309,2.2216223 0.000203191106,3.21641742 3.60512186e-08,4.44371335 C-0.000203119003,5.59580068 0.858228564,6.55700193 1.97735897,6.65778353 L3.25804843,14.5355713 C3.30147283,14.8034368 3.52738125,14.9998958 3.79219386,15 L22.2116024,15 C22.476415,14.9998958 22.7023234,14.8034368 22.7457478,14.5355713 L24.0264373,6.65778353 C25.2184496,6.54814774 26.098111,5.46830024 25.9912006,4.24590016 C25.8911467,3.10167744 24.9570906,2.22433064 23.8368428,2.22219522 Z"
              id="Shape"
              fill="#FFC107"
            />
            <Ellipse
              id="Oval"
              fill="#FFA000"
              cx="13"
              cy="13.5"
              rx="9"
              ry="2.5"
            />
            <Path
              d="M13,17 C8.03,17 3,15.9700156 3,14 C3,12.0299844 8.03,11 13,11 C17.97,11 23,12.0299844 23,14 C23,15.9700156 17.97,17 13,17 Z M13,11.9999844 C7.16442708,11.9999844 4.11109375,13.2999688 4.11109375,14 C4.11109375,14.7000313 7.16442708,16.0000156 13,16.0000156 C18.8355729,16.0000156 21.8889063,14.7000313 21.8889063,14 C21.8889063,13.2999688 18.8355729,11.9999844 13,11.9999844 Z"
              id="Shape"
              fill="#FFD54F"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

Crown.defaultProps = {
  width: 28,
  height: 19,
};

export default Crown;
